module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10189.5378e007.jpg";